import { isFreshFeedbackPayload } from "./feedbackUiVersion";

function getCoachParagraph(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return "";
  const studentFeedback = payload.student_feedback;
  if (studentFeedback && typeof studentFeedback === "object" && !Array.isArray(studentFeedback)) {
    return String(
      studentFeedback.coach_feedback_paragraph ||
        studentFeedback.paragraph ||
        studentFeedback.summary ||
        ""
    ).trim();
  }
  const feedback = payload.feedback;
  if (feedback && typeof feedback === "object" && !Array.isArray(feedback)) {
    return String(feedback.coach_feedback_paragraph || feedback.paragraph || feedback.summary || "").trim();
  }
  return "";
}

export function isKnownStaleW1L1FeedbackPayload(lessonId, payload) {
  if (String(lessonId || "").trim() !== "W1L1") return false;
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return false;
  const score = Number(payload.score ?? payload.overall_score ?? payload.rubric_score ?? null);
  const coachParagraph = getCoachParagraph(payload).toLowerCase();
  const staleFragments = [
    "the moment where you mention",
    "your response already feels personal because it connects creative writing",
    "your writing shows intent",
  ];
  return score <= 61 && staleFragments.some((fragment) => coachParagraph.includes(fragment));
}

export function shouldRefreshW1L1FeedbackPayload(lessonId, payload) {
  if (String(lessonId || "").trim() !== "W1L1") return false;
  return !isFreshFeedbackPayload(payload) || isKnownStaleW1L1FeedbackPayload(lessonId, payload);
}
